module.exports = __webpack_public_path__ + "img/print_heartprint@2x.557c7c4.webp";